import { motion } from "framer-motion";
import { CONTACT } from "../data/content";

export const WhatsAppIcon = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden>
    <path d="M17.5 14.4c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.77-1.66-2.07-.17-.3-.02-.46.13-.61.14-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.8.37-.27.3-1.04 1.02-1.04 2.48s1.07 2.88 1.22 3.08c.15.2 2.1 3.2 5.08 4.49.71.31 1.26.49 1.7.63.71.23 1.36.2 1.87.12.57-.09 1.76-.72 2-1.41.25-.7.25-1.29.18-1.41-.08-.13-.28-.2-.57-.35M12.05 21.78h-.01a9.87 9.87 0 0 1-5.03-1.38l-.36-.21-3.74.98 1-3.65-.24-.37a9.86 9.86 0 0 1-1.51-5.26c0-5.45 4.44-9.88 9.9-9.88a9.83 9.83 0 0 1 7 2.9 9.83 9.83 0 0 1 2.9 7c0 5.45-4.45 9.88-9.9 9.88m8.41-18.3A11.82 11.82 0 0 0 12.05 0C5.5 0 .16 5.33.16 11.89c0 2.1.55 4.14 1.59 5.95L.06 24l6.3-1.65a11.9 11.9 0 0 0 5.68 1.45h.01c6.55 0 11.89-5.33 11.89-11.89 0-3.18-1.24-6.16-3.48-8.41" />
  </svg>
);

export const WhatsAppButton = () => (
  <motion.a
    href={CONTACT.whatsapp}
    target="_blank"
    rel="noopener noreferrer"
    initial={{ opacity: 0, scale: 0.6, y: 20 }}
    animate={{ opacity: 1, scale: 1, y: 0 }}
    transition={{ delay: 2.4, duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
    whileHover={{ scale: 1.06 }}
    whileTap={{ scale: 0.96 }}
    className="fixed bottom-5 right-5 z-[65] group flex items-center gap-3 pl-3 pr-3 sm:pr-5 h-14 border border-[var(--gold)] bg-[rgba(10,10,11,0.85)] backdrop-blur-xl text-[var(--gold)] hover:bg-[var(--gold)] hover:text-[#0a0a0b] transition-colors duration-500 rounded-full shadow-[0_20px_50px_-20px_rgba(212,175,55,0.5)]"
    aria-label="Per WhatsApp kontaktieren"
    data-testid="whatsapp-button"
  >
    <span className="w-8 h-8 flex items-center justify-center"><WhatsAppIcon size={24} /></span>
    <span className="hidden sm:flex flex-col leading-none text-left">
      <span className="font-mono text-[0.55rem] tracking-[0.25em] uppercase opacity-70">Direkt vom Handy</span>
      <span className="text-sm font-semibold mt-1">WhatsApp</span>
    </span>
  </motion.a>
);
